/**
 * PDP: repositions .kl-hub-favorites-slot (app block) when it appears and on breakpoint changes.
 * Matches product-slider breakpoint (1100px).
 *
 * Mobile: immediately after .product__title (title is an h1 — block UI cannot go inside the heading).
 * Desktop: last child of .product-slider__desktop .product-slider__main (theme DOM; not .product > …).
 */
(function () {
  const BREAKPOINT_PX = 1100;
  const SLOT_SELECTOR = '.kl-hub-favorites-slot';
  const SECTION_SELECTOR = 'section.product__section';

  function getSection() {
    return document.querySelector(SECTION_SELECTOR);
  }

  function isDesktop() {
    return window.matchMedia(`(min-width: ${BREAKPOINT_PX}px)`).matches;
  }

  function headingTag(titleEl) {
    return titleEl && /^H[1-6]$/i.test(titleEl.tagName);
  }

  function placeMobile(slot, titleEl) {
    if (headingTag(titleEl)) {
      titleEl.insertAdjacentElement('afterend', slot);
    } else {
      titleEl.appendChild(slot);
    }
  }

  function isPlacedCorrectly(slot, titleEl, desktopMain, desktop) {
    if (desktop) {
      return slot.parentElement === desktopMain && slot === desktopMain.lastElementChild;
    }
    if (headingTag(titleEl)) {
      return titleEl.nextElementSibling === slot;
    }
    return slot.parentElement === titleEl && slot === titleEl.lastElementChild;
  }

  function refreshDesktopSwiper() {
    const slider = document.querySelector(`${SECTION_SELECTOR} product-slider`);
    if (slider && slider.mainSwiper && typeof slider.mainSwiper.update === 'function') {
      slider.mainSwiper.update();
    }
  }

  function place() {
    const section = getSection();
    if (!section) return;

    const slot = section.querySelector(SLOT_SELECTOR);
    if (!slot) return;

    // Two title-wrappers can exist (the mobile-before copy + the in-place one).
    // Pick the one currently visible so the slot never lands in a hidden container.
    const titleEls = section.querySelectorAll('.product .product__title-wrapper');
    let titleEl = null;
    for (let i = 0; i < titleEls.length; i++) {
      if (titleEls[i].offsetParent !== null) {
        titleEl = titleEls[i];
        break;
      }
    }
    if (!titleEl) titleEl = titleEls[0];
    const desktopMain = section.querySelector(
      'product-slider .product-slider__desktop .product-slider__main'
    );

    const desktop = isDesktop();

    if (desktop) {
      if (!desktopMain) return;
      if (isPlacedCorrectly(slot, titleEl, desktopMain, true)) {
        refreshDesktopSwiper();
        return;
      }
      desktopMain.appendChild(slot);
      refreshDesktopSwiper();
      return;
    }

    if (!titleEl) return;
    if (isPlacedCorrectly(slot, titleEl, desktopMain, false)) return;

    placeMobile(slot, titleEl);
  }

  let rafId = 0;
  function schedulePlace() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () {
      rafId = 0;
      place();
    });
  }

  let mutationTimer = 0;
  function onMutations() {
    if (mutationTimer) clearTimeout(mutationTimer);
    mutationTimer = setTimeout(function () {
      mutationTimer = 0;
      schedulePlace();
    }, 50);
  }

  function init() {
    const section = getSection();
    if (!section) return;

    const mq = window.matchMedia(`(min-width: ${BREAKPOINT_PX}px)`);
    mq.addEventListener('change', schedulePlace);

    let resizeTimer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(schedulePlace, 200);
    });

    new MutationObserver(onMutations).observe(section, { childList: true, subtree: true });

    schedulePlace();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
